import { useEffect } from 'react';
import { router } from '@inertiajs/react';

/**
 * Inertia 1.x brings a page back from history (Back, Forward) as it stored
 * it, without asking the server: a list that changed since this entry was
 * left shows as it was then. This is the address the last such restore
 * landed on, recorded as the popstate fires. Inertia's own popstate handler
 * swaps the page only after resolving its component (a promise later), so
 * the restored page finds this already set when it mounts.
 */
let restoredUrl = null;

if (typeof window !== 'undefined') {
    window.addEventListener('popstate', (event) => {
        // Inertia's entries carry its page; a null state is not one of them.
        if (event.state !== null) restoredUrl = window.location.href;
    });
}

/**
 * Reloads the page's `only` props from the server once, when the page mounts
 * from history; a page reached by a visit already has fresh props and
 * reloads nothing.
 */
export function useReloadOnRestore(only) {
    useEffect(() => {
        if (restoredUrl === null || restoredUrl !== window.location.href) return;
        restoredUrl = null;
        router.reload({ only });
        // eslint-disable-next-line react-hooks/exhaustive-deps -- once, on arrival.
    }, []);
}
